import { createIcon } from '@chakra-ui/react';

export const ChevronDownIcon = createIcon({
  displayName: 'ChevronDownIcon',
  viewBox: '0 0 10 5',
  path: (
    <path
      d="M5 4.3998C4.65 4.3998 4.3 4.2648 4.035 3.9998L0.77501 0.739824C0.63001 0.594824 0.63001 0.354824 0.77501 0.209824C0.92001 0.0648242 1.16001 0.0648242 1.30501 0.209824L4.565 3.4698C4.805 3.7098 5.195 3.7098 5.435 3.4698L8.695 0.209824C8.84 0.0648242 9.08 0.0648242 9.225 0.209824C9.37 0.354824 9.37 0.594824 9.225 0.739824L5.965 3.9998C5.7 4.2648 5.35 4.3998 5 4.3998Z"
      fill="currentColor"
    />
  ),
});
